<script>
  import { format } from 'svelte-i18n';
  import { Input, InputGroup } from '@sveltestrap/sveltestrap';
  import Color from 'color';

  /**
   * Size of the input.
   *
   * @type {string}
   * @default ''
   */
  export let bsSize;

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };

  /**
   * CSS color value.
   * @type {string}
   * @default '#000000'
   */
  export let value = '#000000';

  /**
   * Whether the input is disabled.
   * @type {boolean}
   * @default false
   */
  export let disabled = false;

  /**
   * Whether the input is invalid.
   * @type {boolean}
   * @default false
   */
  export let invalidColor = false;

  let hexValue = '#000000';
  let invalidBg = '#fff';

  $: {
    try {
      const color = Color(value);

      hexValue = color.hex().toLowerCase();
      invalidColor = false;
    } catch (e) {
      invalidColor = true;
      hexValue = '';
    }
  }

  $: bordered = hexValue === '#ffffff' ? 'bordered' : '';
</script>

<InputGroup class={className}>
  <Input
    class="color-swatch-input {bordered}"
    type="color"
    bind:value={hexValue}
    {bsSize}
    invalid={invalidColor}
    on:input={() => (value = hexValue)}
    {disabled}
  />
  <Input
    {...$$restProps}
    class="color-input"
    type="text"
    bind:value
    {bsSize}
    invalid={invalidColor}
    feedback={$format('label.VALIDATION_ERROR_COLOR')}
    {disabled}
  />
  <slot />
</InputGroup>

<style lang="scss" src="./color.scss"></style>
